import { render, staticRenderFns } from "./ClaimCheckList.vue?vue&type=template&id=2a3be14a&"
import script from "./ClaimCheckList.vue?vue&type=script&lang=js&"
export * from "./ClaimCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports